<template>
    <div class="modal-overlay">
        <div class="modal-content">
            <!-- Wrap the icon and title in a flex container -->
            <h3 class="text-2xl font-bold mb-4 flex items-center">
                <!-- Font Awesome Icon -->
                <font-awesome-icon :icon="['fas', 'lock']" class="text-red-500 mr-2" />
                <!-- Title Text -->
                {{ $translate('Private Event') }}
            </h3>
            <p class="text-gray-600 mb-4">{{ $translate('private_message') }}</p>
            <form @submit.prevent="handleSubmit">
                <div class="mb-4">
                    <label class="block text-gray-700 text-sm font-bold mb-2">{{ $translate('Password') }}</label>
                    <input type="password" v-model="password"
                        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        required />
                </div>
                <div class="flex items-center justify-between">
                    <button type="submit"
                        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
                        {{ $translate('Submit') }}
                    </button>
                    <button type="button" @click="handleCancel"
                        class="text-red-500 hover:text-red-700 font-bold py-2 px-4 focus:outline-none focus:shadow-outline">
                        {{ $translate('Return to Event List') }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';

export default {
    name: 'PasswordModal',
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const password = ref('');
        const router = useRouter();

        const handleSubmit = () => {
            emit('submit-password', password.value);
        };

        const handleCancel = () => {
            router.push('/');
        };

        return {
            password,
            handleSubmit,
            handleCancel
        };
    },
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: #fff;
    padding: 1.5rem;
    border-radius: 0.5rem;
    max-width: 500px;
    width: 100%;
}
</style>
